import { Typography, styled } from "@mui/material";

export const TypographyLoginCustom = styled(Typography)(({theme}) => ({
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.main, 
}))

export const TitleCustom = styled(Typography)(({theme}) => ({
  flexGrow: 1,
  fontWeight: theme.typography.fontWeightLight,
}))

export const TextAdapterCustom = styled(Typography)(({theme}) => ({
  [theme.breakpoints.down("sm")]: {display: "none"}
}))
